import { Trans } from "react-i18next";

export const DragPanTooltip = () => {
  return (
    <div className="absolute bottom-2 left-2 pointer-events-none">
      <div className="bg-black/70 text-white text-xs px-2 py-1 rounded">
        <Trans
          i18nKey="doc_viewer.drag_pan_tooltip"
          components={{
            kbd: <kbd className="px-1 rounded bg-white/10" />,
          }}
        />
      </div>
    </div>
  );
};
